import loadable from '@loadable/component';
const Notification = loadable(() => import('./index'), {
  resolveComponent: module => module.Modal,
});
export default Notification;
